var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLsywIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1745722619488,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4914,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 655.36C229.233 655.36 0 591.176 0 512s229.233-143.36 512-143.36 512 64.184 512 143.36-229.233 143.36-512 143.36z m0-245.76c-260.157 0-471.04 45.855-471.04 102.4S251.843 614.4 512 614.4 983.04 568.545 983.04 512 772.157 409.6 512 409.6z",
    fill: "#ffffff",
    "p-id": 4915
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024c-79.176 0-143.36-229.233-143.36-512S432.824 0 512 0s143.36 229.233 143.36 512-64.184 512-143.36 512z m0-983.04c-56.545 0-102.4 210.883-102.4 471.04S455.455 983.04 512 983.04 614.4 772.157 614.4 512 568.545 40.96 512 40.96z",
    fill: "#ffffff",
    "p-id": 4916
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M874.045 874.045c-55.992 55.972-263.475-60.723-463.421-260.669s-316.641-407.43-260.67-463.421c55.993-55.972 263.476 60.723 463.422 260.669s316.641 407.43 260.67 463.421zM584.417 439.583C400.445 255.63 218.911 138.936 178.934 178.933c-39.998 39.978 76.697 221.512 260.649 405.484 183.972 183.952 365.506 300.647 405.483 260.65 39.998-39.978-76.697-221.512-260.649-405.484z",
    fill: "#ffffff",
    "p-id": 4917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M613.376 613.376c-199.946 199.946-407.43 316.641-463.421 260.67-55.972-55.993 60.723-263.476 260.669-463.422s407.43-316.641 463.421-260.67c55.972 55.993-60.723 263.476-260.669 463.422z m231.69-434.442c-39.977-39.998-221.511 76.697-405.483 260.649-183.952 183.972-300.647 365.506-260.65 405.483 39.978 39.998 221.512-76.697 405.484-260.649 183.952-183.972 300.647-365.506 260.65-405.483z",
    fill: "#ffffff",
    "p-id": 4918
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsywIcon);
export default __webpack_public_path__ + "static/media/lsywIcon.95a488d4.svg";
export { ForwardRef as ReactComponent };